export var Command;
(function (Command) {
    Command["Me"] = "/api/auth/me";
    Command["Login"] = "/api/auth/login";
    Command["Upload"] = "/api/admin/upload";
    Command["CourseList"] = "/api/admin/courses";
    Command["Course"] = "/api/admin/courses/{id}";
    Command["LectureList"] = "/api/admin/lectures";
    Command["Lecture"] = "/api/admin/lectures/{id}";
    Command["PersonList"] = "/api/admin/lecturers";
    Command["Person"] = "/api/admin/lecturers/{id}";
    Command["SendTestEmail"] = "/api/admin/courses/{id}/actions/sendTestEmail";
})(Command || (Command = {}));
export var UserRole;
(function (UserRole) {
    UserRole["Admin"] = "ADMIN";
    UserRole["Manager"] = "MANAGER";
})(UserRole || (UserRole = {}));
export var FileAbbr;
(function (FileAbbr) {
    FileAbbr["Image"] = "image";
})(FileAbbr || (FileAbbr = {}));
